import React, { Component } from "react";
import { createStackNavigator } from '@react-navigation/stack';
import SettingsScreen from './SettingsListScreen.js';
import UserProfile from './UserProfileScreen.js';
import MatchingData from './UserMatchingDataScreen.js';

const Stack = createStackNavigator();

export default function SettingsStack({ route, navigation}) {
    return(
        <Stack.Navigator>
            <Stack.Screen name="SettingsScreen" component={SettingsScreen} options={{ title: 'Settings'}} />
            <Stack.Screen name="UserProfile" component={UserProfile} options={{ title: 'Personal Information'}} />
            <Stack.Screen name="MatchingData" component={MatchingData} options={{ title: 'Matching Data'}} />
        </Stack.Navigator>
    )
}

//export default { SettingsStack };